import React, { useEffect, useState } from 'react';
import CustomLoading from '../../components/customLoading/CustomLoading';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import Breadcrumbs from '../../components/BreadCrumbs';
import { BiCheck, BiCopy, BiEdit, BiRefresh, BiTrash } from 'react-icons/bi';
import { toast } from 'react-toastify';
import { formatDate } from '../../utils/FormatDateTime';
import { deleteForumApiCall, getForum } from '../../services/forum';
import GalleryComponent from '../../components/GalleryComponent';
import { GrGallery } from 'react-icons/gr';
import { GoEye, GoEyeClosed } from 'react-icons/go';
import ForumPopView from './ForumPopView';
import ConfirmModal from '../../components/popups/confirmationModal/ConfirmModal';
import { AiFillDelete } from 'react-icons/ai';

function Forum() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [typeFilterStatus, setTypeFilterStatus] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Date", key: "date" },
        { label: "Commodity", key: "commodity_name" },
        { label: "Question", key: "question" },
        { label: "Description", key: "description" },
        { label: "User", key: "user" },
        { label: "Phone", key: "phone" },
        { label: "Replied", key: "replied" },
        { label: "Images", key: "images" },
        { label: "Action", key: "action" },
    ];
    const [modalIsDeleteOpen, setIsDeleteOpen] = useState(false);
    const [isConfirmDelete, setIsConfirmDelete] = useState(false);
    const [openingItem, setOpeningItem] = useState(null);

    const setOpening = (item) => {
        setOpeningItem(item);
    };

    const openDeleteModal = (item) => {
        setOpeningItem(item);
        setIsDeleteOpen(true);
    };

    // Close modal
    const closeDeleteModal = () => {
        setIsDeleteOpen(false);
        setOpeningItem(null);
    };

    const pageSize = 20;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getForum(query || "");
            if (res.status === 200) {
                const data = res.data;
                setData(data);
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    const copyClipboard = (text) => {
        navigator.clipboard.writeText(text)
            .then(() => {
                toast.success('Copied to clipboard!');
            })
            .catch(() => {
                toast.error('Failed to copy address');
            });
    };

    const handleTypeFilterChange = (value) => {
        setTypeFilterStatus(value);
        if (value !== typeFilterStatus) {
            fetchData(`&commodity_name=${value}`);
        }
    };

    const resetFilters = () => {
        setTypeFilterStatus("");
        fetchData("");
    };

    const deleteForum = async (forumId) => {
        try {
            let res = await deleteForumApiCall(forumId);
            if (res.status === 204) {
                fetchData("");
                closeDeleteModal();
                toast.success("Forum deleted successfully");
            } else {
                toast.error("Unable to delete Forum");
            }
        } catch (error) {
            console.error("Error deleting Forum:", error);
        }
    };

    useEffect(() => {
        if (isConfirmDelete) {
            deleteForum(openingItem.id);
            closeDeleteModal();
        }
    }, [isConfirmDelete]);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home', link: '/dashboard' },
            { name: 'Marketing' },
            { name: 'Forum' },
        ]} />
        <div className="flex flex-row justify-between item-center">
            <div className="py-4">
                <StyledHeadingText text={"Forum"} />
            </div>
        </div>
        <>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading size={100} />
                    </div>
                    :
                    <div className="mt-2 flex flex-row gap-2">
                        <div className="flex flex-col flex-1 overflow-x-auto min-w-0">
                            <Table
                                headers={headers}
                                rows={data?.results?.map((item, index) => (
                                    {
                                        date: <p className='cursor-pointer' onClick={() => { setOpening(item) }}>{formatDate(item.created_at)}</p>,
                                        description: <span onClick={() => { setOpening(item) }} className='flex flex-row gap-1 items-center cursor-pointer'><p className="max-w-16 truncate cursor-help" title={item.question}>{item.question ?? "-"}</p></span>,
                                        question: <span onClick={() => { setOpening(item) }} className='flex flex-row gap-1 items-center cursor-pointer'><p className="max-w-52 truncate cursor-help" title={item.description}>{item.description ?? "-"}</p></span>,
                                        commodity_name: <p className='cursor-pointer' onClick={() => { setOpening(item) }}>{item.commodity_name}</p>,
                                        user: <p className='cursor-pointer' onClick={() => { setOpening(item) }}>{item.user}</p>,
                                        phone: <p className='cursor-pointer' onClick={() => { setOpening(item) }}>{item.mobile_number}</p>,
                                        replied: <p onClick={() => { setOpening(item) }} className={item.comment_count && item.comment_count !== 0 ? "text-green-500 font-bold cursor-pointer" : "text-red-700 font-bold cursor-pointer"}>{item.comment_count && item.comment_count !== 0 ? "Replied" : "NR"}</p>,
                                        images: <GalleryComponent openingComponent={item.images?.length > 0 ? <img src={item.images[0]} alt="" className="w-12 h-12 rounded-sm" /> : <GrGallery size={20} />} images={item.images || []} />,
                                        action: <div className='flex flex-row justify-start gap-2 items-center'>{openingItem === item ? <GoEye size={20} color='blue' /> : <GoEyeClosed size={20} className='text-blue-950 cursor-pointer' onClick={() => { setOpening(item) }} />} <BiTrash size={20} className='text-red-500 cursor-pointer' onClick={() => { openDeleteModal(item) }} /> </div>,
                                    }))}
                            />
                            {
                                data.count !== 0 ?
                                    <Pagination
                                        currentPage={currentPage}

                                        pageSize={pageSize}
                                        totalEntries={data?.count}
                                        onPageChange={handlePageChange}
                                        data={data}
                                        setData={setData}
                                    /> : <></>
                            }
                        </div>
                        {
                            openingItem ?
                                <div className="max-w-lg w-full bg-white p-2 rounded-lg border border-gray-600 max-h-screen">
                                    <ForumPopView item={openingItem} />
                                </div> : <></>
                        }
                    </div>
            }
        </>
        <ConfirmModal
            isOpen={modalIsDeleteOpen}
            onRequestClose={closeDeleteModal}
            contentLabel=""
            onClose={closeDeleteModal}
            setIsConfirmDelete={setIsConfirmDelete}
            title="Are you sure to Delete?"
            icon={<AiFillDelete color="red" size={50} />}
        />
    </>);
}

export default Forum;